// extracted by mini-css-extract-plugin
export default {"nowrap":"PayinBlockedNotification_nowrap_ycmY1"};